import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "grid flex-1 text-left text-sm leading-tight" }
const _hoisted_2 = { class: "truncate font-medium" }
const _hoisted_3 = {
  key: 0,
  class: "text-muted-foreground truncate text-xs"
}

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
    import { useInitials } from '@/composables/useInitials';
    import type { AuthUser } from '@/types';
    import { computed } from 'vue';

    interface Props {
        user: AuthUser;
        showEmail?: boolean;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'UserInfo',
  props: {
    user: {},
    showEmail: { type: Boolean, default: false }
  },
  setup(__props: any) {

    const props = __props;

    const { getInitials } = useInitials();

    // Compute whether we should show the avatar image
    const showAvatar = computed(() => props.user.avatar && props.user.avatar !== '');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Avatar), { class: "h-8 w-8 overflow-hidden rounded-lg" }, {
      default: _withCtx(() => [
        (showAvatar.value)
          ? (_openBlock(), _createBlock(_unref(AvatarImage), {
              key: 0,
              src: _ctx.user.avatar || '',
              alt: _ctx.user.name
            }, null, 8, ["src", "alt"]))
          : _createCommentVNode("", true),
        _createVNode(_unref(AvatarFallback), { class: "rounded-lg text-black" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(getInitials)(_ctx.user.name)), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.user.name), 1),
      (_ctx.showEmail)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.user.email), 1))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})